import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import Flickity from 'flickity';
import 'lightgallery/dist/js/lightgallery-all';
import "featherlight/release/featherlight.min.js";

import 'isotope-layout/dist/isotope.pkgd.js';
import 'imagesloaded/imagesloaded.pkgd.js';

import 'flickity-bg-lazyload/bg-lazyload.js';

fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	function preventDefault(e) {
	  e = e || window.event;
	  if (e.preventDefault)
	      e.preventDefault();
	  e.returnValue = false;  
	}

	function keydown(e) {
	    for (var i = keys.length; i--;) {
	        if (e.keyCode === keys[i]) {
	            preventDefault(e);
	            return;
	        }
	    }
	}

	function wheel(e) {
	  preventDefault(e);
	}
	

	function disable_scroll() {
	  if (window.addEventListener) {
	      window.addEventListener('DOMMouseScroll', wheel, false);
	  }
	  window.onmousewheel = document.onmousewheel = wheel;
	  document.onkeydown = keydown;
	}

	function enable_scroll() {
	    if (window.removeEventListener) {
	        window.removeEventListener('DOMMouseScroll', wheel, false);
	    }
	    window.onmousewheel = document.onmousewheel = document.onkeydown = null;  
	}

	function partInViewport(elem) {
		let x = elem.getBoundingClientRect().left;
		let y = elem.getBoundingClientRect().top;
		let ww = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		let hw = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		let w = elem.clientWidth;
		let h = elem.clientHeight;
		return (
			(y < hw &&
			 y + h > 0) &&
			(x < ww &&
			 x + w > 0)
		);
	}

	function revealElements() {
		var revealList = document.querySelectorAll('.reveal,.reveal2')
		for (var i = 0; i < revealList.length; i++) {
			if (partInViewport(revealList.item(i))) {
				revealList.item(i).classList.add('revealed');
			}			
		}
	}

	function lazyloadImages() {
		var lazyloadList = document.getElementsByClassName("lazyload");
		for (var i = 0; i < lazyloadList.length; i++) {
			if (partInViewport(lazyloadList.item(i))) {
				lazyloadList.item(i).classList.add('lazyloaded');
				if (lazyloadList.item(i).getAttribute('data-bg')) {
					var dataBG = lazyloadList.item(i).getAttribute('data-bg');
					lazyloadList.item(i).setAttribute('style', 'background-image: url(' + dataBG + ')');
				} else if(lazyloadList.item(i).getAttribute('data-src')) {
					var dataSRC = lazyloadList.item(i).getAttribute('data-src');
					lazyloadList.item(i).setAttribute('src', dataSRC);
				}
			}			
		}
	}

	function detectTouchscreen() {
	  var result = false;
	  if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
	    // if Pointer Events are supported, just check maxTouchPoints
	    if (navigator.maxTouchPoints > 0) {
	      result = true;
	    }
	  } else {
	    // no Pointer Events...
	    if (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) {
	      // check for any-pointer:coarse which mostly means touchscreen
	      result = true;
	    } else if (window.TouchEvent || ('ontouchstart' in window)) {
	      // last resort - check for exposed touch events API / event handler
	      result = true;
	    }
	  }
	  return result;
	}

	function number_format (number, decimals, dec_point, thousands_sep) {
		// Strip all characters but numerical ones.
		number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
		var n = !isFinite(+number) ? 0 : +number,
			prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
			sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
			dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
			s = '',
			toFixedFix = function (n, prec) {
				var k = Math.pow(10, prec);
				return '' + Math.round(n * k) / k;
			};
		// Fix for IE parseFloat(0.55).toFixed(0) = 0;
		s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
		if (s[0].length > 3) {
			s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
		}
		if ((s[1] || '').length < prec) {
			s[1] = s[1] || '';
			s[1] += new Array(prec - s[1].length + 1).join('0');
		}
		return s.join(dec);
	}

	function countNumberAnimation() {
		var counterList = document.getElementsByClassName("counter");
		for (var i = 0; i < counterList.length; i++) {
			if (partInViewport(counterList.item(i)) && !counterList.item(i).classList.contains("counted")) {
				counterList.item(i).classList.add("counted");
				$(counterList.item(i)).prop('Counter',0).animate({
					Counter: $(counterList.item(i)).text()
				}, {
					duration: 7000,
					easing: 'swing',
					step: function (now) {
						$(this).text(Math.ceil(now));
					}
				});
			}
		}
	}

	revealElements();
	lazyloadImages();
	
	document.addEventListener('scroll', function () {
		revealElements();
		lazyloadImages();
		countNumberAnimation();
	}, {
		passive: true
	});

	// JS for Exklusiv Formular NDA's

	function updateExclusiveObjectNda($select) {
		const ndaType = $select.find('option:selected').data('nda-type');
		const $form = $select.closest('.casawp-contactform-form');

		const $defaultNda = $form.find('.nda-text-default');
		const $alternativeNda = $form.find('.nda-text-alternative');
		const $ndaRow = $form.find('.nda-wrapper');
		const $checkbox = $form.find('#dataProtection');

		// Reset everything first
		$defaultNda.hide();
		$alternativeNda.hide();
		$checkbox.prop('checked', false);
		$checkbox.val('');

		// Nothing selected yet
		if (!ndaType) {
			$ndaRow.hide();
			return;
		}

		// Show NDA area
		$ndaRow.show();

		if (ndaType === 'alternative') {
			$alternativeNda.show();
			$checkbox.val('Aussenprovision akzeptiert');
		} else {
			$defaultNda.show();
			$checkbox.val('Innenprovision akzeptiert');
		}
	}

	$(document).on('change', '.control-betreff', function () {
		updateExclusiveObjectNda($(this));
	});

	// Initial state
	$('.control-betreff').each(function () {
		updateExclusiveObjectNda($(this));
	});

	$('.data-protection label').parent().append('<i class="fal fa-check"></i>');

	var selectedLanguage = 'en';
	var $proximityList = $('#proximityList');
	if ($proximityList.length) {
		if ($proximityList.hasClass('proximity-list-invest')) {
			$.ajax({
				url: '/',
				type: 'GET',
				dataType: 'html',
				data: {
					small_list: 1,
					post_type: 'casawp_property',
					utilities: 'investment',
					posts_per_page: 4,
					exclude_id: $proximityList.data('id'),
					language: selectedLanguage // Add language parameter
				},
			})
			.done(function(html) {
				if (html) {
					$('#proximityList').html(html);

				} else {
					$('.close-properties').hide();
				};
			})
		} else {
			var lat = ($proximityList.data('lat') ? parseFloat($proximityList.data('lat')) : 47.446995);
			var lng = ($proximityList.data('lng') ? parseFloat($proximityList.data('lng')) : 8.369695);
			var street = ($proximityList.data('street') ? $proximityList.data('street') : false);

			$.ajax({
				url: '/',
				type: 'GET',
				dataType: 'html',
				data: {
					small_list: 1,
					post_type: 'casawp_property',
					salestypes: $proximityList.data('salestype'),
					my_lat: lat,
					my_lng: lng,
					radius_km : 10,
					posts_per_page: 4,
					exclude_id: $proximityList.data('id'),
					language: selectedLanguage // Add language parameter
				},
			})
			.done(function(html) {
				if (html) {
					$('#proximityList').html(html);

				} else {
					$('.close-properties').hide();
				};
			})
		}
	}

	// $('.karteSchliessen').addClass('d-none');
	// $('.casawp-filterform-button--map').on('click', function(e){
	// 	e.preventDefault();
	// 	if ($('.map-wrap').hasClass('hide-map')) {
	// 		$('.map-wrap').removeClass('hide-map');
	// 		$(this).find('.karteAnzeigen').addClass('d-none');
	// 		$(this).find('.karteSchliessen').removeClass('d-none');
	// 		$(this).addClass('active');
	// 		// if ($('#casawp-map').length) {
	// 		// 	initializeMapBoxCasaWP();
	// 		// };
	// 	} else {
	// 		$('.map-wrap').addClass('hide-map');
	// 		$(this).find('.karteAnzeigen').removeClass('d-none');
	// 		$(this).find('.karteSchliessen').addClass('d-none');
	// 		$(this).removeClass('active');
	// 	}
	// 	return false;
	// });

	$('#contactFormsearchProfile_categories').chosen({width:"100%",placeholder_text_multiple:'Bitte wählen'});

	$('.gallery').lightGallery({
		selector: '.gallery-item a'
	});

	$('.casawp-main-flickity').lightGallery({
		selector: '.property-image-gallery',
		download: false,
		thumbnail: false
	});

	if ($('.af-submit-button').length) {
		$('.af-submit-button').wrapInner('<span class="linkTextOuter"><span class="linkText"></span></span>');
		$('<span class="the-arrow -left"><span class="shaft"></span></span>').insertAfter('.linkTextOuter');
	}

	if ($('.wpforms-page-prev').length) {
		$('.wpforms-page-prev').wrapInner('<span class="linkTextOuter"><span class="linkText"></span></span>');
		$('<span class="the-arrow -right"><span class="shaft"></span></span>').insertAfter('.wpforms-page-prev .linkTextOuter');
	}

	if ($('.wpforms-page-next').length) {
		$('.wpforms-page-next').wrapInner('<span class="linkTextOuter"><span class="linkText"></span></span>');
		$('<span class="the-arrow -left"><span class="shaft"></span></span>').insertAfter('.wpforms-page-next .linkTextOuter');
	}

	
	if ($('.wpforms-submit').length) {
		$('.wpforms-submit').wrapInner('<span class="linkTextOuter"><span class="linkText"></span></span>');
		$('<span class="the-arrow -left"><span class="shaft"></span></span>').insertAfter('.wpforms-submit .linkTextOuter');
	}

	// WPForms

	if ($('.wpforms-field-radio').length) {
		$('.wpforms-field-radio li label').append('<span class="checkmark"></span>');
	}

	if ($('.wpforms-field-checkbox').length) {
		$('.wpforms-field-checkbox li label').append('<span class="checkmark"></span>');
	}

	if (detectTouchscreen()) {
		$('.nav .menu-item-has-children > a').on('click', function(e){
			e.preventDefault();
			if ($(this).next().hasClass('subOpen')) {
				$('.nav .menu-item-has-children > a').next().removeClass('subOpen');
			} else {
				$('.nav .menu-item-has-children > a').next().removeClass('subOpen');
				$(this).next().addClass('subOpen');
			}
			return false;
		});
	} else {
		$('.nav .menu-item-has-children').on('mouseenter', function(){
			$(this).find('.sub-menu').addClass('subOpen');
		}).on('mouseleave', function(){
			$('.nav .menu-item-has-children').find('.sub-menu').removeClass('subOpen');
		});
	}
	
	if ($('.stoererContent').length) {
		setTimeout(function(){
			$('.stoererContent').addClass('active');
		}, 500)
	}
	

	$('.closeBtn').on('click', function(e){
		e.preventDefault();
		if ($('.stoererContent').hasClass('active')) {
			$('.stoererContent').removeClass('active');
		}
		return false;
	});

	$('.callStoerer').on('click', function(e){
		e.preventDefault();
		if (!$('.stoererContent').hasClass('active')) {
			$('.stoererContent').addClass('active');
		}
		return false;
	});

	if ($('#contactFormsearchProfile_price_from').length) {
		const minPrice = document.getElementById('contactFormsearchProfile_price_from');
		minPrice.addEventListener('keyup', function() {
		  var val = this.value;
		  this.value = number_format(val, 0, '.', '\'');
		});
	}
	
	if ($('#contactFormsearchProfile_price_to').length) {
		const maxPrice = document.getElementById('contactFormsearchProfile_price_to');
		maxPrice.addEventListener('keyup', function() {
			var val = this.value;
			this.value = number_format(val, 0, '.', '\'');
		});
	}

	


	$('.panelHeader a').on('click', function(){
		var src = $(this).find('img').attr('src');
		var endSrc;
		var defaultSrc = src.replace('minus', 'plus')
		$('.panelHeader a').find('img').attr('src', defaultSrc);
		
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
			endSrc = src.replace('minus', 'plus');
			$(this).find('img').attr('src', endSrc);
		} else {
			$('.panelHeader a').removeClass('open');
			$(this).addClass('open');
			endSrc = src.replace('plus', 'minus');
			$(this).find('img').attr('src', endSrc);
		}
	});

	if ($('.casawp-main-flickity').length) {
		var immoSlider = new Flickity('.casawp-main-flickity', {
			cellAlign: 'center',
			draggable: false,
			wrapAround: true,
			pageDots: false,
			imagesLoaded: true,
			prevNextButtons: true,
			autoPlay: 7000,
			arrowShape: { 
				x0: 10,
				x1: 60, y1: 50,
				x2: 65, y2: 45,
				x3: 20
			}
		});
		var carousel = document.querySelector('.casawp-main-flickity');
		var flkty = Flickity.data(carousel);

		var $galleryStatus = $('.gallery-status');

		function updateStatus() {
			var cellNumber = flkty.selectedIndex + 1;
			$galleryStatus.html( '<span style="color: #3F3A39;">' + cellNumber + '</span>' + '/' + flkty.slides.length );
		}
		updateStatus();
		immoSlider.on( 'select', updateStatus );

		window.addEventListener( 'load', function() {
			immoSlider.resize();
		});

		$('.flickity-prev-next-button.previous').html('<svg width="21px" height="9px" viewBox="0 0 21 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g id="Immobilien-detail" transform="translate(-647.000000, -722.000000)" stroke="#DA3E3A"><g id="Group-7" transform="translate(624.000000, 693.000000)"><g id="Arrowto" transform="translate(33.500000, 33.500000) scale(-1, 1) translate(-33.500000, -33.500000) translate(23.000000, 30.000000)"><path d="M0.7,3.5 L20.3,3.5" id="Line"></path><polyline id="Path-2" points="16.8 0 21 3.5 16.8 7"></polyline></g></g></g></g></svg>');
		$('.flickity-prev-next-button.next').html('<svg width="21px" height="9px" viewBox="0 0 21 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g id="Immobilien-detail" transform="translate(-772.000000, -722.000000)" stroke="#DA3E3A"><g id="Group-7" transform="translate(624.000000, 693.000000)"><g id="Arrowto" transform="translate(148.000000, 30.000000)"><path d="M0.7,3.5 L20.3,3.5" id="Line"></path><polyline id="Path-2" points="16.8 0 21 3.5 16.8 7"></polyline></g></g></g></g></svg>');

		$('.flickity-prev-next-button.previous, .flickity-prev-next-button.next').wrapAll('<div class="flktyButtons"></div>');
		$('.gallery-status').appendTo('.flktyButtons');
	}

	$('.navbar-toggler').on('click', function(){
		if ($(this).hasClass('active-nav')) {
			$(this).removeClass('active-nav');
			$('.navbarOuter').removeClass('nav-bg');
		} else {
			$(this).addClass('active-nav');
			$('.navbarOuter').addClass('nav-bg');
		}
	});

	$('.navbar-collapse').on('shown.bs.collapse', function(){
		$('#footer').hide();
		$('#content').hide();
		if ($('.sliderOuter').length) {
			$('.sliderOuter').hide();
		}
		$('#header').css('position', 'absolute');
		$('.navbar-toggler').removeClass('dontClick');
	});

	$('.navbar-collapse').on('show.bs.collapse', function(){
		$('.navbar-toggler').addClass('dontClick');
		$('html, body').animate({
			scrollTop: $('html, body').offset().top
		}, 300);
		
	});

	$('.navbar-collapse').on('hidden.bs.collapse', function(){
		$('.navbar-toggler').removeClass('dontClick');
	});

	$('.navbar-collapse').on('hide.bs.collapse', function(){
		$('#header').css('position', 'fixed');
		$('#footer').show();
		$('#content').show();
		if ($('.sliderOuter').length) {
			$('.sliderOuter').show();
		}
		
		$('.navbar-toggler').addClass('dontClick');
	});

	$('.toBottom').on('click', function(){
		disable_scroll();
		$('html, body').stop().animate({
			scrollTop: $('#content').offset().top - 122
		}, 700, function(){
			enable_scroll();
		});
		return false;
	});

	$('.scroll-down').on( 'click', function(e){
		e.preventDefault();
		disable_scroll();
		$('html, body').stop().animate({
			scrollTop: $(this).parent().parent().next().offset().top - $('#header').outerHeight()
		}, 700, function () {
			enable_scroll();
		});
		return false;
	})

	$('.next.page-numbers').html('<svg width="22px" height="9px" viewBox="0 0 22 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g id="Immobilien-kaufen" transform="translate(-785.000000, -3081.000000)" stroke="#DA3E3A"><g id="Group-4" transform="translate(632.000000, 3072.000000)"><g id="Arrowto" transform="translate(153.000000, 10.000000)"><path d="M0.733333333,3.5 L21.2666667,3.5" id="Line"></path><polyline id="Path-2" points="17.6 0 22 3.5 17.6 7"></polyline></g></g></g></g></svg>');
	$('.prev.page-numbers').html('<svg width="22px" height="9px" viewBox="0 0 22 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g id="Immobilien-kaufen" transform="translate(-632.000000, -3081.000000)" stroke="#DA3E3A"><g id="Group-4" transform="translate(632.000000, 3072.000000)"><g id="Arrowto" transform="translate(11.000000, 13.500000) scale(-1, 1) translate(-11.000000, -13.500000) translate(0.000000, 10.000000)"><path d="M0.733333333,3.5 L21.2666667,3.5" id="Line"></path><polyline id="Path-2" points="17.6 0 22 3.5 17.6 7"></polyline></g></g></g></g></svg>');

	if ($('.slider').length) {
		var flky = new Flickity( '.slider', {
			cellAlign: 'left',
			wrapAround: true,
			autoPlay: 7000,
			imagesLoaded: true,
			prevNextButtons: false,
			pageDots: true,
			bgLazyLoad: true,
			draggable: false
		});
		window.addEventListener( 'load', function() {
			flky.resize();
		});			
	}

	if ($('.slideable-banner__slider').length) {
		$('.slideable-banner__slider').each(function(index, sl){
			var flky = new Flickity( sl, {
				cellAlign: 'left',
				wrapAround: true,
				autoPlay: 7000,
				imagesLoaded: true,
				prevNextButtons: false,
				pageDots: false,
				bgLazyLoad: true,
				draggable: false
			});
			window.addEventListener( 'load', function() {
				flky.resize();
			});	
		})
	}

	if ($('.testimonials-slider').length) {
		var flky = new Flickity( '.testimonials-slider', {
			cellAlign: 'left',
			wrapAround: true,
			//autoPlay: 7000,
			imagesLoaded: true,
			prevNextButtons: false,
			pageDots: true,
			bgLazyLoad: true,
			draggable: true,
			adaptiveHeight: true,
			//setGallerySize: false,
			groupCells: true
		});
		window.addEventListener( 'load', function() {
			flky.resize();
		});			
	}

	var heightVars = ['.matchMe', '.titleMatch', '.text1stContents', '.text2ndContents'];
	$.each(heightVars, function(i, obj){
		if ($(this).length){
			var maxHeight = 0;
			$(this).each(function(i, obj) {
				if($(this).height() > maxHeight){
					maxHeight = $(this).height();
				}
			});
			$(this).height(maxHeight);
		}
	});
	if ($('.ratgeberPlaceholder').length){
		var maxHeight = 0;
		$('.thumbOuter').each(function(i, obj) {
			if($('.thumbOuter').height() > maxHeight){
				maxHeight = $(this).height();
			}
		});
		$('.ratgeberPlaceholder').height(maxHeight);
	}
	if ($('.singleHeader').length){
		var headerHeight = $('#header').height();
		$('.singleHeader').css('margin-top', headerHeight);
	}

	window.addEventListener('touchstart', function onFirstTouch() {
		// we could use a class
		document.body.classList.add('user-is-touching');
		// or set some global variable
		window.USER_IS_TOUCHING = true;
		// we only need to know once that a human touched the screen, so we can stop listening now
		window.removeEventListener('touchstart', onFirstTouch, false);
		$('.ratgeberCTAWrap').addClass('user-is-touching');
	}, false);


	function initializeMap($mapwraper) {
		if ($('.marker').length) {
			var markerIcon = $('.marker').data('marker');
		}
		var location = new google.maps.LatLng($mapwraper.data('lat'),$mapwraper.data('lng'));
		var mapOptions = {
			zoom: parseInt(window.casawpOptionParams.google_maps_zoomlevel),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: location,
			mapTypeControlOptions: {
			mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'gray_map']
			}
		};
		$mapwraper.show();
		var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

		var marker = new google.maps.Marker({
			map: map,
			position: location,
			icon: new google.maps.MarkerImage(
					markerIcon,
					new google.maps.Size(21,29),
					null,
					null,
					new google.maps.Size(21,29)
				)
		});
		map.mapTypes.set('gray_map',
			new google.maps.StyledMapType([{stylers: [{saturation: -90}]}],
				{name: "Gray Map"}));
		map.setMapTypeId('gray_map');

		map.setCenter(new google.maps.LatLng($mapwraper.data('lat'),$mapwraper.data('lng')));

		map.setOptions({maxZoom: 12});
	}
	
	if ($('.casawp-map').length && google) {
		$('.casawp-map').each(function(){
			var $mapwraper = $(this);
			if ($mapwraper.data('lat') && $mapwraper.data('lng')) {
				var map;
				//initializeMap($mapwraper);
				if ($('#casawp-mapShowBtn').length) {
					$('#casawp-mapShowBtn').on('click', function() {
						console.log("click");
						if ($('#casawp-mapShowBtn').length) {
							$('#casawp-mapShowBtn').css('display', 'none');
						}
						if ($('.casawp-map__placeholder').length) {
							$('.casawp-map__placeholder').css('display', 'none');
						}
						$('.casawp-map').css('display', 'block');
						initializeMap($mapwraper);
					});
				} else {
				initializeMap($mapwraper);
				}
			}
		});
	}

	if ($('.chosen-single').length) {
		$('.chosen-single').append('<i class="fal fa-angle-down"></i>');
	}

	$('.wpforms-field-select select').parent().append('<i class="fal fa-angle-down"></i>');

	$('.form-group select').parent().append('<i class="fal fa-angle-down"></i>');

	$('.main-menu .menu-item-has-children > a, .wpml-ls-item a:first').append('<i class="fal fa-angle-down"></i>');

	$('.navbar-collapse').on('shown.bs.collapse', function(){
		/*$('#footer').hide();
		$('#content').hide();
		$('.sliderOuter').hide();*/
		$('.navbar-toggler').removeClass('dontClick');
	});

	$('.navbar-collapse').on('show.bs.collapse', function(){
		$('.navbar-toggler').addClass('dontClick');
	});

	$('.navbar-collapse').on('hidden.bs.collapse', function(){
		$('.navbar-toggler').removeClass('dontClick');
	});

	$('.navbar-collapse').on('hide.bs.collapse', function(){
		/*$('#footer').show();
		$('#content').show();
		$('.sliderOuter').show();*/
		$('.navbar-toggler').addClass('dontClick');
	});

	

	var $grid = $('.grid').isotope({
		itemSelector: '.grid-item'
	});


	$grid.imagesLoaded().progress( function() {
		$grid.isotope('layout');
	});

	// featherlight
	var configuration = {
		closeOnEsc: true,
		closeOnClick: 'background',
		variant: 'objects',
		beforeOpen: function(event){
			if($('.featherlight.objects.initialized').length){
				$('.featherlight.objects').show();
				$('html').addClass('with-featherlight');
				return false; // prevent lightbox from opening
			} else{
				$('.featherlight.objects').addClass('initialized');
			}
		},
		beforeClose: function(event){
			//console.log(this); // this contains all related elements
			$('.featherlight.objects').hide();
			$('html').removeClass('with-featherlight');
			return false; // prevent lightbox from opening
		},
	  };

	  countNumberAnimation();

	// Content Video
	$(".video-wrapper .overlay-play").on('click', function(){
		if($(this).siblings(".content__video")[0].paused){
			$(this).siblings(".content__video")[0].play();
			$(this).fadeOut();   
		} 
// 		else{
// 	    	// 	$(this).siblings(".video")[0].pause();
// 	  		// $(this).fadeIn();
// 		}
	})

	$(".content__video").on('click', function(){
		if($(this)['0'].paused){
			$(this)['0'].play();
			$(this).siblings(".overlay-play").fadeOut();   
		} else{
			$(this)['0'].pause();
			$(this).siblings(".overlay-play").fadeIn();
		}
	})



	$(".page-numbers.next").addClass("btn").addClass("btn-primary");
	if ($("html").attr("lang") == "en-US") {
		$(".next.page-numbers").html('<svg class="svg-inline--fa fa-angle-down fa-w-8" aria-hidden="true" data-prefix="fal" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" data-fa-i2svg=""><path fill="currentColor" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"></path></svg> <span>More properties</span>');
	}  else {
		$(".next.page-numbers").html('<svg class="svg-inline--fa fa-angle-down fa-w-8" aria-hidden="true" data-prefix="fal" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" data-fa-i2svg=""><path fill="currentColor" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"></path></svg> <span>Weitere Objekte</span>');
	}


	function loadProperties($elem) {
		$elem.on('click', function (e) {
			e.preventDefault();
			var nextPropertyUrl = $elem.attr("href");
			$elem.closest(".col-lg-12").find(".fa-spinner").show();
			$elem.remove();

			console.log(nextPropertyUrl);
			console.log('123');
			$(".casawp-dummy").load(
				nextPropertyUrl + " .casawp-archive-list .colProp, .col--load",
				function () {
					$(this)
						.find(".colProp")
						.each(function (index, cl) {
							$(cl).insertBefore(".casawp-archive-list .col--load");
						});
					$(this)
						.find(".col--load .next")
						.appendTo(".casawp-archive-list .col--load");

					$(".page-numbers.next").addClass("btn").addClass("btn-primary");
					if ($("html").attr("lang") == "en-US") {
						$(".next.page-numbers").html('<svg class="svg-inline--fa fa-angle-down fa-w-8" aria-hidden="true" data-prefix="fal" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" data-fa-i2svg=""><path fill="currentColor" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"></path></svg> <span>More properties</span>');
					}  else {
						$(".next.page-numbers").html('<svg class="svg-inline--fa fa-angle-down fa-w-8" aria-hidden="true" data-prefix="fal" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" data-fa-i2svg=""><path fill="currentColor" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"></path></svg> <span>Weitere Objekte</span>');
					}

					$(".fa-spinner").hide();
					var y = $(window).scrollTop(); //your current y position on the page
					$("html, body").animate({ scrollTop: y + 150 }, 600);
					loadProperties($(".page-numbers.next"));

				}
			);
		});
	}
	loadProperties($(".page-numbers.next"));

	// Get the select element
	var selectElement = document.querySelector('select[name="locations[]"]');
	if (selectElement !== null) {
		// Get all options within the select element
		var options = selectElement.querySelectorAll('option');

		// Iterate through each option and replace "CH" with "Schweiz"
		options.forEach(function(option) {
			option.textContent = option.textContent.replace(/\bCH\b/g, 'Schweiz');
		});
	}
	$('.chosen-select').chosen({width:"100%"});

	function saveSelectedValue() {
		var selectedValue = $('#price_for_order_to_select').val();
		sessionStorage.setItem('selectedPriceForOrderTo', selectedValue);
	}

	function restoreSelectedValue() {
		var selectedValue = sessionStorage.getItem('selectedPriceForOrderTo');
		if (selectedValue) {
			$('#price_for_order_to_select').val(selectedValue).trigger('chosen:updated');
			updateHiddenFields(selectedValue);
		}
	}

	function updateHiddenFields(selectedValue) {
		var priceFromInput = $('#price_for_order_from');
		var priceToInput = $('#price_for_order_to');
		console.log('selected value ' + selectedValue);
		if (selectedValue === 'up5000000') {
			priceFromInput.val('5000000');
			priceToInput.val('');
		} else {
			priceFromInput.val('');
			priceToInput.val(selectedValue);
		}
	}

	function initializeChosen() {
		$('#price_for_order_to_select').chosen().change(function() {
			var selectedValue = $(this).val();
			updateHiddenFields(selectedValue);
			saveSelectedValue();
		});
	}

	initializeChosen();

	$('.casawp-filterform').on('submit', function() {
		saveSelectedValue();
	});

	$('.casawp-filterform').on( "casawp-filterform:after-filter-reload", function(event, url, filteredUrl){
		restoreSelectedValue();
		var selectElement = document.querySelector('select[name="locations[]"]');
		if (selectElement !== null) {
			// Get all options within the select element
			var options = selectElement.querySelectorAll('option');

			// Iterate through each option and replace "CH" with "Schweiz"
			options.forEach(function(option) {
				option.textContent = option.textContent.replace(/\bCH\b/g, 'Schweiz');
			});
		}	
		$('.chosen-select').chosen({width:"100%"});
		initializeChosen();
	});

	$(".casawp-ajax-archive-list").on(
		"casawp-ajaxfilter:after-list-reload",
		function (event, url, filteredUrl) {
			revealElements();
			lazyloadImages();
			// console.log(filteredUrl);
			// console.log('after-list-reload');

			//archive Properties get url parameter
			// var $form = $('.casawp-filterform');
		    // var filteredParams = $form.serialize();
			// var filteredUrl = myAddParameterAndReturn('?' + filteredParams);
			// filteredUrl = filteredUrl + '&posts_per_page=100';

			$(".page-numbers.next").addClass("btn").addClass("btn-primary");
			if ($("html").attr("lang") == "en-US") {
				$(".next.page-numbers").html('<svg class="svg-inline--fa fa-angle-down fa-w-8" aria-hidden="true" data-prefix="fal" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" data-fa-i2svg=""><path fill="currentColor" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"></path></svg> <span>More properties</span>');
			}  else {
				$(".next.page-numbers").html('<svg class="svg-inline--fa fa-angle-down fa-w-8" aria-hidden="true" data-prefix="fal" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" data-fa-i2svg=""><path fill="currentColor" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"></path></svg> <span>Weitere Objekte</span>');
			}

			loadProperties($(".page-numbers.next"));
		}
	);

	$('.open-cookie').on('click', function(){
		CCM.openWidget(); return false;
	});



	

});





// WEBPACK FOOTER //
// ./src/js/main.js